import React, { useEffect, useState } from 'react'

import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import enUs from '../i18n/en_us'
import ptBr from '../i18n/pt_br'
import { bowtieReducer } from './genericReducer'
import { useJSON, Data } from './hooks'
import MobileBowtie from './MobileBowtie'
import { bowtieStyle, buildScenario, hasTagStyle } from './utils'

const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}
i18n.add(localeFiles[locale])

function MobileBowtieWidget({
    state,
    height,
    widget
}: LiveReactChartProps<any[], FlowMessage, DefaultChartConfigs>): JSX.Element {
    const data: Data = useJSON()
    const [scenarios, setScenarios] = useState(null)

    if (!hasTagStyle()) document.head.appendChild(bowtieStyle)

    useEffect(() => {
        if (data) {
            const scenarioJSON = buildScenario(data)
            setScenarios(scenarioJSON)
        }
    }, [data])

    return (
        state && (
            <MobileBowtie ships={data?.ships} scenarios={scenarios} event={state[0]} height={height} widget={widget} />
        )
    )
}

widgetService.register({
    type: 'mobileBowtie',
    name: 'Mobile Bowtie',
    description: 'Mobile Bowtie',
    config: {},
    impl: reactWidgetWrapper(MobileBowtieWidget, bowtieReducer)
})
